module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/7b2SRO7bhDM7I5SuLs4DAP-b58145b30743618118bce3601acaf299.jpg";